export function useArchiveYear() {
    const regex = /(naujienos)\/([0-9]+)/;
    const archive_url_matches = typeof window === 'undefined' ? null : window.location.pathname.match(regex);
    if (archive_url_matches === null)
        return null;
    return (archive_url_matches === null || archive_url_matches === void 0 ? void 0 : archive_url_matches.at(2)) ? archive_url_matches[2] : null;
}
